'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/Rating.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rating = function (_BcReactComponent) {
  _inherits(Rating, _BcReactComponent);

  function Rating(props) {
    _classCallCheck(this, Rating);

    var _this = _possibleConstructorReturn(this, (Rating.__proto__ || Object.getPrototypeOf(Rating)).call(this, props));

    _this.state = {
      selectedRating: 0,
      submitted: false
    };

    _this.bindAll('updateRating', 'handleRatingButtonClick', 'handleRemoveItemRating', 'renderStars');
    return _this;
  }

  _createClass(Rating, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          rating = _props.rating,
          readOnly = _props.readOnly;

      if (rating && !readOnly) {
        this.setState({
          selectedRating: rating,
          submitted: true
        });
      }
    }
  }, {
    key: 'updateRating',
    value: function updateRating(selectedRating) {
      if (this.state.submitted) {
        return false;
      }

      return this.setState({ selectedRating: selectedRating });
    }
  }, {
    key: 'handleRatingButtonClick',
    value: function handleRatingButtonClick(rating) {
      if (this.state.submitted) {
        return;
      }

      this.updateRating(rating);
      this.props.handleButtonClick(rating);
      this.setState({ submitted: true });
    }
  }, {
    key: 'handleRemoveItemRating',
    value: function handleRemoveItemRating() {
      var _props2 = this.props,
          metadataId = _props2.metadataId,
          removeItemRating = _props2.removeItemRating;


      this.setState({ selectedRating: 0, submitted: false });
      removeItemRating(metadataId);
    }
  }, {
    key: 'renderStars',
    value: function renderStars() {
      var stars = [];
      var _props3 = this.props,
          metadataId = _props3.metadataId,
          readOnly = _props3.readOnly;

      var rating = this.props.rating || 0;
      var normalizedRating = void 0;

      if (readOnly) {
        // If the rating is read only, round up to the nearest star
        normalizedRating = Math.round(rating / 10) * 10;
      } else if (this.state.selectedRating > 0) {
        normalizedRating = this.state.selectedRating;
      } else {
        normalizedRating = rating;
      }

      var halfStars = normalizedRating % 20 > 0 ? 1 : 0;

      // Full stars
      _lodash2.default.times(Math.floor(normalizedRating / 20), function (n) {
        stars.push(_react2.default.createElement(_baseIcons.StarFull, { key: 'star_full_' + n + '_' + metadataId, className: 'rating-star star-full', color: '#f4a204' }));
      });

      // Half stars
      _lodash2.default.times(halfStars, function (n) {
        stars.push(_react2.default.createElement(_baseIcons.StarHalf, { key: 'star_half_' + n + '_' + metadataId, className: 'rating-star star-half', color: '#f4a204' }));
      });

      // Empty stars
      _lodash2.default.times(5 - Math.round(normalizedRating / 20), function (n) {
        stars.push(_react2.default.createElement(_baseIcons.StarEmpty, { key: 'star_empty_' + n + '_' + metadataId, className: 'rating-star star-empty', color: '#f4a204' }));
      });

      return stars;
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      var _this2 = this;

      var _props4 = this.props,
          metadataId = _props4.metadataId,
          readOnly = _props4.readOnly;


      if (readOnly) {
        return _react2.default.createElement('noop', null);
      }

      return _lodash2.default.times(10, function (n) {
        var value = (n + 1) * 10;
        var starCount = (n + 1) / 2;
        return _react2.default.createElement(
          _baseButtons.DefaultButton,
          {
            key: 'rating_button_' + n + '_' + metadataId,
            className: 'rating-button',
            role: 'button',
            onMouseOver: function onMouseOver() {
              return _this2.updateRating(value);
            },
            onTouchStart: function onTouchStart() {
              return _this2.handleRatingButtonClick(value);
            },
            onFocus: function onFocus() {
              return _this2.updateRating(value);
            },
            handleClick: function handleClick() {
              return _this2.handleRatingButtonClick(value);
            } },
          starCount + ' star' + (starCount === 1 ? '' : 's')
        );
      });
    }
  }, {
    key: 'renderRemoveButton',
    value: function renderRemoveButton() {
      var readOnly = this.props.readOnly;

      if (this.state.submitted && !readOnly) {
        return _react2.default.createElement(
          _baseButtons.TextButton,
          { className: 'remove-rating-button', 'aria-label': 'Remove rating button', handleClick: this.handleRemoveItemRating },
          _react2.default.createElement(_baseIcons.Remove, null)
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props5 = this.props,
          id = _props5.id,
          metadataId = _props5.metadataId,
          rating = _props5.rating,
          readOnly = _props5.readOnly,
          type = _props5.type;


      if (!rating && readOnly) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-rating ' + type, 'aria-labelledby': id },
        _react2.default.createElement(
          'div',
          { className: 'rating-star-wrap' },
          this.renderStars()
        ),
        _react2.default.createElement(
          'div',
          {
            role: 'region',
            id: 'rating_select_' + metadataId,
            className: 'rating-star-button-wrap ' + (this.state.submitted ? 'submitted' : ''),
            onMouseLeave: function onMouseLeave() {
              return _this3.updateRating(0);
            },
            onBlur: function onBlur() {
              return _this3.updateRating(0);
            } },
          _react2.default.createElement(
            'div',
            { 'aria-controls': 'rating_select_' + metadataId, 'aria-label': 'Rating stars' },
            this.renderButtons()
          )
        ),
        this.renderRemoveButton(),
        _react2.default.createElement(
          'span',
          { className: 'sr-only', id: id },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'screenReaderStarRating',
            values: {
              rating: rating / 20
            } })
        )
      );
    }
  }]);

  return Rating;
}(_baseBcReactComponent2.default);

Rating.propTypes = {
  rating: _react.PropTypes.number, // integer 0 - 100
  id: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string.isRequired,
  readOnly: _react.PropTypes.bool,
  handleButtonClick: _react.PropTypes.func,
  removeItemRating: _react.PropTypes.func,
  metadataId: _react.PropTypes.string
};

Rating.displayName = 'Rating';

exports.default = Rating;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/rating/lib/components/Rating.component.js
// module id = 1009
// module chunks = 4